import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import digital from '../../assets/img/digital.svg';
// import interactionwhite from '../../assets/img/interaction-white.png';
import tax from '../../assets/img/tax.svg';
import astro from '../../assets/img/astro.svg';
import heal from '../../assets/img/heal.svg';
import { Tab } from 'react-bootstrap';
import { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import { IMAGE_URL } from '../../api';
import { useEffect } from 'react';
import { getTaskCategoryList } from '../../Redux/Task/action';
import serviceslogo from '../../assets/img/serviceslogo.png';

const Services = () => {

    const [categories, setCategories] = useState();
    const { state } = useLocation();
    // const [servicesimg, setServicesimg] = useState(false);

    // const [key, setKey] = useState('home');
    useEffect(() => {
        getTaskCategoryList()((response) => {
            if (response && response.status) {
                setCategories(response?.data?.data)
            }


        });
    }, []);

    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Services </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Services</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container-xxl service">
                    <div className="container">
                        <div className="row g-4 wow fadeInUp">
                            {categories &&
                                <Tab.Container id="left-tabs-example" defaultActiveKey={state?.category_id ? state?.category_id : categories[0]?.id}>
                                    <Row>
                                        <Col lg={3} md={4} sm={12}>
                                            <Nav variant="pills" className="flex-column">
                                                {categories?.map((category, index) =>
                                                    <Nav.Item key={index}>
                                                        <Nav.Link className='nav-link w-100 d-flex align-items-center text-start border p-4 mb-4 wrappper-color' eventKey={category?.id}>
                                                            <img src={IMAGE_URL + category?.logo} alt='Digital' className='img-fluid me-3 tabs-img' />
                                                            <h5 className="m-0">{category?.name}</h5>
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                )}
                                                {/* <Nav.Item>
                                                        <Nav.Link className='nav-link w-100 d-flex align-items-center text-start border p-4 mb-4' eventKey="second"><h5 className="m-0"><img src={tax} alt='Tax' className='img-fluid me-3' />Tax</h5></Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link className='nav-link w-100 d-flex align-items-center text-start border p-4 mb-4' eventKey="third"><h5 className="m-0"><img src={astro} alt='Astro' className='img-fluid me-3' />Astro</h5></Nav.Link>
                                                    </Nav.Item>
                                                    <Nav.Item>
                                                        <Nav.Link className='nav-link w-100 d-flex align-items-center text-start border p-4 mb-4' eventKey="fourth"><h5 className="m-0"><img src={heal} alt='Heal' className='img-fluid me-3' />Heal</h5></Nav.Link>
                                                    </Nav.Item> */}
                                            </Nav>
                                        </Col>
                                        <Col lg={9} md={8} sm={12}>
                                            <Tab.Content>
                                                {categories?.map((category, index) =>
                                                    <Tab.Pane eventKey={category?.id} key={index}>
                                                        <section id="services" className="services sections-bg">
                                                            <div className="container">
                                                                <div className="row gy-4">
                                                                    {category?.task.map((subtask, subIndex) =>
                                                                        <div className="col-lg-6 col-md-6" key={subIndex}>
                                                                            <Link className='' to={'/posttask/' + subtask?.id}>
                                                                                <div className="service-item  position-relative">
                                                                                    <div className="icon">
                                                                                        {/* <i className="bi bi-activity"></i> */}
                                                                                        <img src={serviceslogo} alt="" className='img fluid' />
                                                                                    </div>
                                                                                    <h3>{subtask?.name}</h3>
                                                                                </div>
                                                                            </Link>
                                                                        </div>
                                                                    )}
                                                                    {/* <div className="col-lg-6 col-md-6">
                                                                                <Link className='' to='/posttask'>
                                                                                    <div className="service-item  position-relative">
                                                                                        <div className="icon">
                                                                                            <i className="bi bi-broadcast"></i>
                                                                                        </div>
                                                                                        <h3>Audio Video Editing</h3>
                                                                                    </div>
                                                                                </Link>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6">
                                                                                <Link className='' to='/posttask'>
                                                                                    <div className="service-item  position-relative">
                                                                                        <div className="icon">
                                                                                            <i className="bi bi-easel"></i>
                                                                                        </div>
                                                                                        <h3>Digital Marketing</h3>
                                                                                    </div>
                                                                                </Link>
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6">
                                                                                <Link className='' to='/posttask'>
                                                                                    <div className="service-item  position-relative">
                                                                                        <div className="icon">
                                                                                            <i className="bi bi-columns-gap"></i>
                                                                                        </div>
                                                                                        <h3>Others</h3>
                                                                                    </div>
                                                                                </Link>
                                                                            </div> */}
                                                                </div>
                                                            </div>
                                                        </section>
                                                    </Tab.Pane>
                                                )}
                                                {/* <Tab.Pane eventKey="second">
                                                        <section id="services" className="services sections-bg">
                                                            <div className="container">
                                                                <div className="row gy-4">
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-percent"></i>
                                                                                </div>
                                                                                <h3>GST</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-chat-square-text"></i>
                                                                                </div>
                                                                                <h3>ITR</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-columns-gap"></i>
                                                                                </div>
                                                                                <h3>Others</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </section>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="third">
                                                        <section id="services" className="services sections-bg">
                                                            <div className="container">
                                                                <div className="row gy-4">
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-mortarboard"></i>
                                                                                </div>
                                                                                <h3>Career</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-people"></i>
                                                                                </div>
                                                                                <h3>Relationship</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-columns-gap"></i>
                                                                                </div>
                                                                                <h3>Others</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </section>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="fourth">
                                                        <section id="services" className="services sections-bg">
                                                            <div className="container">
                                                                <div className="row gy-4">
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-mortarboard"></i>
                                                                                </div>
                                                                                <h3>Career</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-people"></i>
                                                                                </div>
                                                                                <h3>Relationship</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <Link className='' to='/posttask'>
                                                                            <div className="service-item  position-relative">
                                                                                <div className="icon">
                                                                                    <i className="bi bi-columns-gap"></i>
                                                                                </div>
                                                                                <h3>Others</h3>
                                                                            </div>
                                                                        </Link>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </section>
                                                    </Tab.Pane> */}
                                            </Tab.Content>
                                        </Col>
                                    </Row>
                                </Tab.Container>
                            }
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment >
    )
}

export default Services;